import { combineReducers } from 'redux';
import tables from './tables';
import context from './context';
import forms from './forms';
import flash from './flash';
import breadcrumb from './breadcrumb';
import modalForms from './modal.forms';
import tabs from './tabs';
import lineup from './lineup';

export default combineReducers({
    tables,
    context,
    forms,
    flash,
    breadcrumb,
    modalForms,
    tabs,
    lineup
});
